<style lang="less" scoped>

/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
.totalNum{
    margin-top: 20px;
    font-weight: bold;
}
/deep/ .input-table{
    .ivu-input{
        border: 1px solid #fff;
    }
}
</style>

<template>
<div>
    <Modal
        class-name="vertical-center-modal"
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'700px'}">


        <Button type="info"  @click="creatData" style="margin-bottom:18px; border-radius: 6px;">{{$t("productManage.manageModel.new")}}</Button>
        
       <Table  max-height="500" border :columns="titleName" :data="tableList.tableData"  :loading='loading'></Table>
       <!-- <div class="totalNum" v-if='local=="en-US"'>Total {{totalNum}} items</div>
       <div class="totalNum" v-else>共 {{totalNum}} 条</div> -->

        <!-- 删除弹框组件 -->
      <DeleteDialog ref="deleteChild" @ievent = "ievent"  :title='$t("orderManage.deletModel.changeTitle")' :cont='$t("orderManage.deletModel.changeCont")'></DeleteDialog>
       
    </Modal>

      <SModelBox :showModel.sync="addBox.showModel" :fn="addBox.callbackFn" :editFormData="addBox.editFormData"></SModelBox>

      
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import SModelBox from './sAddModel';
import DeleteDialog from '../../common/deleteModel.vue'; // 引入删除弹框组件
import { mapState } from 'vuex'
    export default {
        props: {
            showModel: Boolean,
            fn:Function
        },
        name: "Model3",
        components: {
            SModelBox,
            DeleteDialog
        },
        data() {
            return {
                loading:true,
                title: '',//弹框标题
                formData:{},
                totalNum:'20',
                tableList:{//表格组
                    hasSelectData:{},//已选中的行的数据
                    tableData: []//表格数据
                },
                addBox:{//规格弹框组-移动
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                }
            }
        },
        watch:{
            showModel(val){
                if(val){
                    this.getData()
                }
            }
        },
        computed:{
            ...mapState(['local','selectId']),
            titleName(){
                return [
                    {
                        title: this.$t('productManage.manageModel.Product_group'),
                        key: 'groupName',
                        minWidth: 180,
                        render: (h, params) => {
                          //使用抽离出的getRender函数，来执行后续的render行为
                            return h('Input', this.getRender(h, params, 'groupName','input')); 
                        }
                    },
                    {
					    title: this.$t('productManage.manageModel.Operation'),
					    minWidth:120,
                        key: "id",
					    render: (h, params) => {
                            let that = this
                            return [
                                h('Button', {
					                props: {
                                        type: "error",
                                        size: 'small'
                                    },
                                    style:{
                                        display:'block',
                                        margin:'0 auto'
                                    },
					                on: {
					                    click: () => { this.todelData(params.row) }
					                }
					            },that.$t("delete"))
                            ]
					    }
					},
                ]
            }

        },
        created(){
        },
        methods: {
            getRender(h, params, key,types){
                return{
                    props: {
                        value: params.row[key]
                    },
                    class:"input-table",  // 定义一个类来控制单元格的样式
                    style:{
                        width:'100%!important'
                    },
                    on:{
                        'on-blur':(event) => {
                           //获取编辑行的inde和编辑字段名，对表格数据进行重新赋值，注意：与下拉框取值不一样
                           if(types == 'input'){
                                let resVal = (event.currentTarget.value).trim()
                                if(resVal==params.row.groupName){
                                    return
                                }
                          		this.tableList.tableData[params.index][params.column.key] = resVal; 
                              
                                this.axios.post(this.config.urlArray.productsGroupSet, {'groupName':resVal,id:params.row.id,dealerId:this.selectId}).then((result) => {
                                    common.ajaxMsg(result.data,true);
                                    this.getData()
                                    
                                }).catch((err) => {
                                   
                                    this.disabled = false;
                                });
                           }else if(types == 'select'){
                               //下拉框选择获取编辑行的inde和编辑字段名，对表格数据进行重新赋值
                          		// this.tableList.tableData[params.index][params.column.key] = event
                           }
                            
                        }
                    }
                }
            },
            creatData(){//新建组织
                this.cancel()
                this.addBox.showModel = true
                this.addBox.callbackFn = () => {//回调处理
                    this.$emit('update:showModel',true);
                    //重新载入
                    this.addBox.showModel = false;
                    // this.getData();
                    
                }

            },
            todelData(item) {// 删除
                this.tableList.hasSelectData = item
                this.$refs.deleteChild.showit();
            },
            ievent() {// 删除
                // console.log('删除',this.tableList.hasSelectData.id)
                this.axios.post(this.config.urlArray.productsGroupDel, {id:this.tableList.hasSelectData.id}).then((result)=>{
                    common.ajaxMsg(result.data,true,()=>{

                        this.$refs.deleteChild.recancel();
                        this.getData();
                    })
                }).catch((err)=>{
                    common.msg('error',this.$t('failed'))
                })
            },
            getData(){
                let getData = {
                    params: {
                      dealerId:this.selectId
                    }
                }
    
                this.axios.post(this.config.urlArray.productsGroupList, getData.params).then((result) => {
                    // common.ajaxMsg(result.data);
                    let resData = result.data.data
                    resData = resData.map((item)=>{
                        item.marketDate1 = moment(item.marketDate/1).format('YYYY-MM-DD')
                        return item
                    })
                    //处理数组
                    this.tableList.tableData  =  resData
                    // this.page.total = result.data.data.paging.total
                    this.loading = false
                }).catch((err) => {
                    // common.msg('error','获取失败',()=>{})
                });
            },
           
            openOrClose(value) {
                if(value === true) {        
                    this.title = this.$t('productManage.manageModel.title')
                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                }
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>
